import { Certification } from 'common/types/entities/api/certification'
import { fetchCertification } from 'common/services/certification'
import { StateKey } from 'common/utils/flipState'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'

const initialState: Certification = {
  resultCode: null,
  resultMsg: null,
  mtlCefNo: null,
  bsmNm: null,
  mtlNm: null,
  matlBscMdlNm: null,
  matlDerivMdlNm: null,
  matlMfrNm: null,
  dtlInfCdNm: null,
  cvaPcsYmd: null,
  matlEtcMtr: null,
  cacheParam: null,
}

const FETCH = 'certification/FETCH'

export const fetch = (curState: StateKey, certificationNo: string) => async (dispatch, getState) => {
  const cacheParam = createCacheParam(FETCH, 'fetch', { curState, certificationNo })
  if (isCacheHit(getState().certification[curState], cacheParam)) {
    return
  }
  const certification = await fetchCertification(certificationNo)
  dispatch({
    curState,
    certification,
    cacheParam,
    type: FETCH,
  })
}

const certificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        ...action.certification,
        cacheParam: action.cacheParam,
      }
    default:
      return state
  }
}

export default certificationReducer
